import React from 'react';
import '../../styles/style.css';
import discover1 from "../../assets/images/Discover1.png";
import discover2 from "../../assets/images/Discover2.png";
import discover3 from "../../assets/images/Discover3.png";

const Discover = () => (
  <div className="discover">
    <div className="container">
      <div className="row">
        <h1>Discover why we have so many repeat clients!</h1>
      </div>
      <div className="row">
        <div className="col-md-4">
          <div className="box">
            <img src={discover1} alt="Discover 1" />
            <h5>15 Years of Experience</h5>
            <p>Sunboundvillas have been providing tailored holidays in the Algarve for happy customers since 2009.</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="box">
            <img src={discover2} alt="Discover 2" />
            <h5>Local Expertise</h5>
            <p>With our office in Almancil you can be assured of our first hand knowledge. Our resort team is always available.</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="box">
            <img src={discover3} alt="Discover 3" />
            <h5>Handpicked Properties</h5>
            <p>With our office in Almancil you can be assured of our first hand knowledge. Our resort team is always available.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Discover;